import { Reveal } from "@/components/Reveal";

export function SectionLabel({ children, dark = false, num }) {
  return (
    <div className="flex items-center gap-3">
      {num && (
        <span className={`font-mono text-[11px] ${dark ? "text-clay" : "text-clay"}`}>{num}</span>
      )}
      <span
        className={`font-mono text-[11px] uppercase tracking-[0.25em] ${
          dark ? "text-invtext" : "text-subtext"
        }`}
      >
        {children}
      </span>
    </div>
  );
}

export function PageHero({ eyebrow, title, intro }) {
  return (
    <section className="border-b border-line bg-paper pt-32 pb-16 md:pt-40 md:pb-24">
      <div className="mx-auto max-w-[1400px] px-6 md:px-12 lg:px-16">
        <Reveal>
          <SectionLabel>{eyebrow}</SectionLabel>
        </Reveal>
        <div className="mt-8 grid grid-cols-1 gap-8 md:grid-cols-12">
          <Reveal className="md:col-span-8" delay={0.05}>
            <h1 className="font-display text-4xl font-medium leading-[1.02] tracking-tight text-ink sm:text-5xl lg:text-6xl">
              {title}
            </h1>
          </Reveal>
          {intro && (
            <Reveal className="md:col-span-4 md:pt-2" delay={0.15}>
              <p className="text-base leading-relaxed text-subtext md:text-lg">{intro}</p>
            </Reveal>
          )}
        </div>
      </div>
    </section>
  );
}
